"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchFilterParams = exports.useSearchFilters = exports.commonSearchFilterParams = exports.commonSearchFilters = void 0;
const react_1 = require("react");
const models_1 = require("../../models");
exports.commonSearchFilters = {
    category: (r, path, params) => !params.get(`page`) || (r.page === params.get(`page`))
};
exports.commonSearchFilterParams = {
    s: { name: "Services you need", filter: models_1.Filter.Multiselect, param: "s", values: [], includeInFilterCount: true },
    os: { name: "Open Saturdays", filter: models_1.Filter.Checkbox, param: "os", values: [], includeInFilterCount: false },
    ot: { name: "Open today or tomorrow", filter: models_1.Filter.Checkbox, param: "ot", values: [], includeInFilterCount: false },
    ow: { name: "Open weekdays after 5pm", filter: models_1.Filter.Checkbox, param: "ow", values: [], includeInFilterCount: false },
    ap: { name: "Appointment booking", filter: models_1.Filter.Checkbox, param: "ap", values: [], includeInFilterCount: true },
    fa: { name: "Language of service", filter: models_1.Filter.Checkbox, param: "fa", values: [], includeInFilterCount: true },
    wa: { name: "Accessibility", filter: models_1.Filter.Checkbox, param: "wa", values: [], includeInFilterCount: true }
};
const useSearchFilters = (records, filters = []) => {
    // Execute only in browser (not server-side)
    const w = (typeof window !== "undefined") ?
        ({ search: window.location.search, path: window.location.pathname }) : ({ search: '', path: '' });
    const path = w.path;
    const searchParams = new URLSearchParams(w.search);
    const applyFilters = !filters.length ? [exports.commonSearchFilters.category] : filters;
    return (0, react_1.useMemo)(() => {
        return records.filter(r => applyFilters.every((f) => f(r, path, searchParams)));
    }, [records, w.search, w.path]);
};
exports.useSearchFilters = useSearchFilters;
const useSearchFilterParams = () => {
    // Execute only in browser (not server-side)
    const search = (typeof window !== "undefined") ? window.location.search : '';
    const searchParams = new URLSearchParams(search);
    return (0, react_1.useMemo)(() => {
        const returnObj = {};
        Array.from(searchParams.keys())
            .filter(k => exports.commonSearchFilterParams[k])
            .forEach((k) => {
            var _a, _b;
            returnObj[k] = {
                name: exports.commonSearchFilterParams[k].name,
                filter: exports.commonSearchFilterParams[k].filter,
                param: k,
                values: ((_a = searchParams.get(k)) === null || _a === void 0 ? void 0 : _a.length) && ((_b = searchParams.get(k)) === null || _b === void 0 ? void 0 : _b.split(',')) || [],
                includeInFilterCount: exports.commonSearchFilterParams[k].includeInFilterCount
            };
        });
        return returnObj;
    }, [searchParams]);
};
exports.useSearchFilterParams = useSearchFilterParams;
